module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-badge"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Badge")]), _vm._v(" "), _c('div', {
    staticClass: "page-badge-container"
  }, [_c('div', {
    staticClass: "page-part"
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "error",
      "size": "large"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "success",
      "size": "large"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "warning",
      "size": "large"
    }
  }, [_vm._v("10")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("10")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "error",
      "size": "small"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "warning",
      "size": "small"
    }
  }, [_vm._v("10")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-badge', {
    attrs: {
      "size": "small",
      "color": "#888"
    }
  }, [_vm._v("自定义颜色")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-cell', {
    attrs: {
      "title": "徽章"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("未读消息")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "error",
      "size": "small"
    }
  }, [_vm._v("10")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59909eb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/badge.vue
// module id = 298
// module chunks = 0